export default __webpack_public_path__ + "static/media/create-color-palette.a71685dc.png";